import * as favoritesApi from '@/network/api/favorites.api.js'
import * as accountApi from '@/network/api/accounts.api.js'
import * as cardsApi from '@/network/api/cards/cards.api.js'

/** requests Favorites Tabs
@return {promise} - Tabs request
*/
export const requestTabs = async (context) => {
    const res = await favoritesApi.getFavoritesTabs()
    if (res) {
        const data = res.data
        context.commit('SAVE_TABS', data)
    }
    return res
}

/** requests Favorites List
@return {promise} - Tabs request
*/
export const requestFavorites = async (context, payload) => {
    const res = await favoritesApi.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    if (context.state.accountsBalances.length) return

    const res = await accountApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests Cards List
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
    if (context.state.cardsList.length) return

    const res = await cardsApi.cards(payload)
    if (res) {
        const data = res.data
        context.commit('SAVE_CARDS', data)
    }
    return res
}

/** creates new Favorite
@return {promise}
*/
export const createNewFavorite = async (context, payload) => {
    const res = await favoritesApi.addFavorite(payload)
    return res
}

/** edits Favorite Name
@return {promise}
*/
export const editFavoriteName = async (context, payload) => {
    const res = await favoritesApi.editFavorite(payload)
    return res
}

/** removes Favorite
@return {promise}
*/
export const deleteFavorite = async (context, id) => {
    const res = await favoritesApi.removeFavorite(id)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
